import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { StrategyContext } from 'pages/context/StrategyContext';
import { useStrategiesApi } from 'pages/hooks/useStrategiesApi';

import { Card } from 'components/cards/Card';
import { ManageStrategyModal } from 'components/modals/strategies/ManageStrategyModal';
import { Page } from 'components/page/Page';

import { StrategiesGrid } from './components/StrategiesGrid';

const StrategiesPage = () => {
  const { search } = useLocation();
  const { getData } = useStrategiesApi();
  useEffect(() => {
    getData();
  }, [getData, search]);
  return (
    <Page title="Strategies">
      <Card>
        <StrategiesGrid />
      </Card>
    </Page>
  );
};

export default () => {
  return (
    <StrategyContext>
      <StrategiesPage />
      <ManageStrategyModal />
    </StrategyContext>
  );
};
